document.addEventListener('DOMContentLoaded', () => {
    // removing license banner 
    Statamic.$app.showBanner = false;

    if(typeof window.parent.redirectBack === "function") {
        Statamic.$hooks.on('entry.saved', function(resolve, reject, payload) {
            window.parent.redirectBack();
        });
    }

});

Statamic.booting(() => {

    const user = Statamic.$config.get('user');
    Statamic.$conditions.add('hasRole', ({ target, params }) => {
        let roles = params;
        return user.roles.some(role => roles.includes(role))
    });
});